import React, { forwardRef } from "react";

const Divider = ({ className }) => <span className={className} aria-hidden="true" />;

export const StickyCourseBar = ({ ce, featured, visible, activeIdx }) => (
  <div
    data-testid="coach-ed-sticky-bar"
    aria-hidden={!visible}
    className={`fixed inset-x-0 top-20 z-40 bg-[#0F1B2D]/95 backdrop-blur border-b border-[#C4A46A]/30 transition-all duration-300 ${
      visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 -translate-y-2 pointer-events-none"
    }`}
  >
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-3 lg:py-4">
      <div className="flex items-center gap-4 lg:gap-8 overflow-x-auto">
        <div className="overline text-[#C4A46A] shrink-0 hidden sm:block">{ce.browseLabel}</div>
        <nav className="flex items-center gap-x-5 lg:gap-x-7 whitespace-nowrap">
          {featured.map((fc, idx) => (
            <React.Fragment key={fc.title}>
              {idx > 0 && <Divider className="inline-block h-3 w-px bg-[#C4A46A]/50" />}
              <a
                href={`#course-${idx}`}
                data-testid={`coach-ed-sticky-anchor-${idx}`}
                className={`font-cormorant italic text-base lg:text-lg leading-tight transition-colors ${
                  activeIdx === idx ? "text-[#C4A46A]" : "text-white/80 hover:text-[#C4A46A]"
                }`}
              >
                {fc.title}
              </a>
            </React.Fragment>
          ))}
        </nav>
      </div>
    </div>
  </div>
);

export const CourseAnchorMenu = forwardRef(({ ce, featured }, ref) => (
  <section ref={ref} className="bg-[#F4F0E8] border-b border-[#0F1B2D]/10" data-testid="coach-ed-anchor-menu">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 lg:py-8">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-10">
        <div className="overline text-[#5E6470] shrink-0">{ce.browseLabel}</div>
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-3 lg:gap-x-8">
          {featured.map((fc, idx) => (
            <React.Fragment key={fc.title}>
              {idx > 0 && <Divider className="hidden sm:inline-block h-3 w-px bg-[#C4A46A]/60" />}
              <a
                href={`#course-${idx}`}
                data-testid={`coach-ed-anchor-${idx}`}
                className="font-cormorant italic text-[#0F1B2D] text-lg lg:text-xl leading-tight hover:text-[#C4A46A] transition-colors"
              >
                {fc.title}
              </a>
            </React.Fragment>
          ))}
        </nav>
      </div>
    </div>
  </section>
));
CourseAnchorMenu.displayName = "CourseAnchorMenu";
